module.exports = __webpack_public_path__ + "img/武汉漾颜.6da5457.png";